import { Pipe, PipeTransform } from '@angular/core';

/**
 * WHO DID IT, AS A PERSON (Joel, 2026-10-08: "showing the guid for added by is useless. it should
 * resolve to the Users Full name and username"). DataServices sends a display object beside every
 * actor id (DS cd52529): name is always present (a real name, the email, or "Unknown user") and
 * username is the email when known. The id fields stay on the wire for now; the console never shows
 * them.
 */
export interface ActorDisplay {
  name: string;
  username?: string | null;
}

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * "Full Name (username)", or just the name when there is no username or it equals the name.
 *
 * NEVER AN ID. Without a display object, a legacy value is shown only if it is an email address (old
 * alert acknowledgements carry one); anything else, a GUID or an object id, reads "Unknown user".
 */
export function formatActor(user?: ActorDisplay | null, legacy?: string | null): string {
  const name = user?.name?.trim();
  if (name) {
    const username = user?.username?.trim();
    return username && username.toLowerCase() !== name.toLowerCase() ? `${name} (${username})` : name;
  }
  const fallback = (legacy ?? '').trim();
  if (fallback && fallback.includes('@') && !GUID.test(fallback)) return fallback;
  return 'Unknown user';
}

/** {{ row.addedByUser | actor }} or {{ ack.user | actor: ack.email }}. */
@Pipe({ name: 'actor', standalone: true })
export class ActorPipe implements PipeTransform {
  transform(user?: ActorDisplay | null, legacy?: string | null): string {
    return formatActor(user, legacy);
  }
}
